const ACCOUNT_LEVEL = {
  pending: 'pending',
  basic: 'basic',
  limitless: 'limitless'
};

export default ACCOUNT_LEVEL;
